export const commonConstants = {
    USERS_SUCCESS: 'GET_USERS_SUCCESS',
    WORKFLOW_PROCESS_SUCCESS: 'GET_WORKFLOW_PROCESS_SUCCESS',
    IATA_VALIDATION_SUCCESS: 'GET_WORKFLOW_PROCESS_SUCCESS',
    AIRLINES_SUCCESS: 'GET_AIRLINES_SUCCESS',
    AIRLINES_CARRIERS_SUCCESS: 'GET_AIRLINES_CARRIERS_SUCCESS',
    DES_AIRPORTS_SUCCESS: 'GET_DES_AIRPORTS_SUCCESS',
    DEP_AIRPORTS_SUCCESS: 'GET_DEP_AIRPORTS_SUCCESS',
    AIRPORTS_SUCCESS: 'GET_AIRPORTS_SUCCESS',
    COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
    FLIGHT_DAYS_SUCCESS: 'GET_FLIGHT_DAYS_SUCCESS',
    INVOICE_RECONCILIATION_SUCCESS: 'GET_INVOICE_RECONCILIATION_SUCCESS',
    DASHBOARD_FILTER: 'DASHBOARD_FILTER',
    FTP_CREDENTIALS_SUCCESS: 'GET_FTP_CREDENTIALS_SUCCESS',
    PDF_DOWNLOAD_TYPE: 2,
    EXCEL_DOWNLOAD_TYPE: 1,
    GET_TICKET_CATEGORY: 'GET_TICKET_CATEGORY',
    GET_TICKET_CLASS: 'GET_TICKET_CLASS',
    GET_ENTITIES: 'GET_ENTITIES',
    GET_FLAG_METRICS: 'GET_FLAG_METRICS',
    GET_AIRLINE_LOCATIONS: 'GET_AIRLINE_LOCATIONS',
    DASHBOARD_SUCCESS: 'DASHBOARD_SUCCESS',
};


// WEBPACK FOOTER //
// ./src/_constants/common.constants.js